import type { NewCommitmentCommandData } from '@festina/life-general-types/life'
import { useTranslate } from '@festina-life/ui/hooks'
import { useMemo } from 'react'
import { useNavigate } from 'react-router'

import { useVariantAction } from '../../hooks/useVariantAction'
import { useHook } from '../../lenteHooks'
import { withLifeErrorBoundary } from '../../libs/withLifeErrorBoundary'
import { generalRoutes } from '../../routing/generalRoutes'
import { CommandModalButton } from '../commandActions/CommandModalButton'
import type { CommitmentActionButtonProps } from '../commandActions/types'
import { NewCommitmentCommandDataForm } from './NewCommitmentCommandDataForm'

/**
 * @privateRemarks
 * TODO: Camilla or someoneelse needs to check up on this
 */
function CreateCommitmentCommandInternal(props: CommitmentActionButtonProps) {
  const { tenantId, ownerId } = useHook('routing.general.useEntityParams')()
  const actions = useHook('mutators.life.useCommitmentActions')({
    tenantId,
    ownerId,
    ...props,
  })

  const translate = useTranslate()
  const navigate = useNavigate()

  const submit = useVariantAction({
    ...props,
    actions,
  })

  const submitWrapper = useMemo(() => {
    if (!submit) {
      return undefined
    }

    return {
      ...submit,
      onSubmit: async (values: NewCommitmentCommandData) => {
        await submit.onSubmit(values)
        await navigate(
          generalRoutes.commitment.workbench({ tenantId, ownerId }),
        )
      },
    }
  }, [navigate, ownerId, submit, tenantId])

  return (
    <CommandModalButton
      actionId="life.NewCommitmentCommandData"
      title={translate('createCommitmentModalButton.title')}
      commandDataForm={NewCommitmentCommandDataForm}
      {...props}
      submit={submitWrapper}
    />
  )
}

export const CreateCommitmentCommand = withLifeErrorBoundary(
  CreateCommitmentCommandInternal,
)
